<div nz-row nzGutter="8" nzType="flex" nzJustify="space-between" nzAlign="middle">
    <div nz-col nzXs="24" nzXl="15">
        <small>{{ nzTitle }}</small>
    </div>
    <div nz-col nzXs="24" nzXl="9" class="text-right-xl">
        <small class="font-weight-semibold">{{ nzValue }}</small>
        <sup><i *ngIf="isCustomTooltip" class="fsmicon-info pl-2" nz-tooltip [nzTooltipTitle]="customTitle" nzTooltipPlacement="right"></i></sup>
    </div>
</div>
<nz-divider class="my-2"></nz-divider>